import React, { ReactElement, PropsWithChildren } from "react";
import useSocialNetworkLinksStyles, {
  SocialNetworkLinksClasses,
} from "./styles";

export type SocialNetworkData = {
  icon?: ReactElement;
  link?: string;
};

export type SocialNetworkLinksProps = {
  socialNetworks?: Array<SocialNetworkData>;
};

function SocialNetworkLinks({
  socialNetworks = [],
}: PropsWithChildren<SocialNetworkLinksProps>): ReactElement {
  const useStyles: SocialNetworkLinksClasses = useSocialNetworkLinksStyles();

  const SocialNetworkLinksGenerator = socialNetworks.map((data, i) => {
    return (
      <li key={i}>
        <a href={data.link} className={useStyles.socialNetworkItem}>
          {data.icon}
        </a>
      </li>
    );
  });

  return (
    <ul className={useStyles.socialNetworkList}>
      {SocialNetworkLinksGenerator}
    </ul>
  );
}
export default SocialNetworkLinks;
